module.exports = __webpack_public_path__ + "static/media/IEEE-CS_Logo1.fb8774bd.jpg";